import React from "react";
import { motion } from "framer-motion";
import logo from "../logo.png";
import backgroundImage from "../back.webp";
import "@fontsource/chivo";
import "@fontsource/dancing-script/400.css";
import { Link } from "react-router-dom";

const ChiSiamo = () => {
  return (
    <section className="w-full px-4 sm:px-6 py-12 sm:py-16 bg-white">
      {/* Title */}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true, amount: 0.3 }}
        className="text-center text-[#00B8C0] text-3xl sm:text-4xl md:text-5xl font-[chivo] mb-10 sm:mb-12"
      >
        Chi Siamo
      </motion.h2>

      {/* Content with Background Image */}
      <div
className="w-full max-w-[90%] sm:max-w-[95%] mx-auto bg-cover bg-center rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.4)] hover:shadow-[0_10px_40px_rgba(0,0,0,0.5)] transition duration-300"

        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        {/* White Overlay */}
        <div className="bg-white/50 p-6 sm:p-10 rounded-xl text-center flex flex-col justify-center min-h-[500px]">


          {/* Text */}
          <motion.p
  initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true, amount: 0.3 }}
  className="text-black text-lg sm:text-xl md:text-2xl leading-[2.2rem] sm:leading-[2.5rem] md:leading-[2.8rem] font-[chivo] max-w-4xl mx-auto"

>
  Lo stabilimento balneare <strong>"Lido Da Vittorio"</strong> è situato nella cittadina di Vico Equense, e più precisamente presso la località{" "}
  <strong>"Postali"</strong>, una conca dal panorama mozzafiato dalla quale è possibile ammirare da un lato, tutto il Golfo di Napoli, e dall'altro la costa verdeggiante che cade a strapiombo sul mare. <br /><br />
  Meravigliosi e unici sono anche i tramonti, con il sole che va a riposare dietro il caratteristico scoglio della Margherita.
</motion.p>


          {/* Logo */}
          <div className="mt-10">
            <img
              src={logo}
              alt="Lido Da Vittorio"
              className="h-28 sm:h-32 md:h-36 mb-6 mx-auto sm:mb-8"
            />
          </div>

          {/* Button */}
          <Link to="/da-vittorio">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true, amount: 0.3 }}
              className="mt-10 sm:mt-12"
            >
              <button className="text-[18px] sm:text-[22px] md:text-[26px] px-6 sm:px-8 md:px-10 py-2 sm:py-3 border-2 border-[#009FB7] bg-[#009FB7] text-white rounded-full hover:bg-transparent hover:text-[#009FB7] transition duration-300 font-[chivo]">
                Continua...
              </button>
            </motion.div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ChiSiamo;
